module.exports = __webpack_public_path__ + "img/diffuser-essential-oils.a90dc60b.svg";